import moment from 'moment'
import { getServerNow } from '@/utils'

const mutations = {
  setLocale (state, payload) {
    state.v_locale = payload
    localStorage.setItem('userLocale', payload)
  },
  setProfile (state, payload) {
    state.profile = payload
  },
  setInfo (state, payload) {
    const delta = moment().diff(moment(payload.timestamp, 'X'))
    state.startTime = moment(payload.begin_time, 'X')
    state.endTime = moment(payload.end_time, 'X')
    state.timeDelta = delta
    state.ctfMode = payload.player_mode
    state.trendTeamNum = payload.trend_team_num
    state.contestInfo = payload.contest_info
    state.contestLogo = payload.contest_logo
    state.ctfName = payload.contest_name
  },
  updateNow (state) {
    state.now = getServerNow()
  },
  setRouter (state, payload) {
    state.router = payload
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js